import { logger } from "@/utils/logger";
/** Vuex kaynak: vehicleAssignment.js — micro-6-2 */
export function timeToMinutes(timeStr) {
    try {
        if (!timeStr)
            return 0;
        const [hours, minutes] = timeStr.split(":").map(Number);
        return hours * 60 + minutes;
    }
    catch (error) {
        logger.error("Zaman dönüştürme hatası:", error);
        return 0;
    }
}
export function calculateEndTime(startTime, duration) {
    try {
        if (!startTime)
            return "00:00";
        let validDuration = 45;
        if (typeof duration === "number" && !isNaN(duration)) {
            validDuration = duration;
        }
        else if (typeof duration === "object" && duration !== null) {
            logger.warn("Süre objesi algılandı, varsayılan süre kullanılıyor:", duration);
        }
        const [hours, minutes] = startTime.split(":").map(Number);
        if (isNaN(hours) || isNaN(minutes)) {
            logger.error("Geçersiz başlangıç zamanı:", startTime);
            return "00:00";
        }
        const totalMinutes = hours * 60 + minutes + validDuration;
        const endHours = Math.floor(totalMinutes / 60);
        const endMinutes = totalMinutes % 60;
        return `${String(endHours).padStart(2, "0")}:${String(endMinutes).padStart(2, "0")}`;
    }
    catch (error) {
        logger.error("Bitiş zamanı hesaplama hatası:", error, {
            startTime,
            duration,
        });
        return "00:00";
    }
}
export function saveVehicleDataToStorage(state) {
    try {
        localStorage.setItem("vehicleAssignments", JSON.stringify({
            vehicles: state.vehicles,
            assignments: state.assignments,
            lastUpdated: new Date().toISOString(),
        }));
        logger.debug("Araç verileri localStorage'a kaydedildi:", new Date());
    }
    catch (err) {
        logger.error("localStorage kayıt hatası:", err);
    }
}
